<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>人物管理 > <b>换脸任务</b></BreadcrumbItem>
      </Breadcrumb>
  
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="task_list"></Table>
		   <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getTaskList"/>
        </Card>
    </Content>
	
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			status:0
		},
		recordTotal:0,
		page:1,
		task_list:[],
		tableColumns:[
		{ title: 'ID', key: 'id', align: 'center' },
		{ title: '头像', key: 'pic', align: 'center',
			render:(h,params) =>{
			   return h('img',{
				 attrs : {src : params.row.pic},
				 style : { width : '80px', height : '80px' }
			   })
		}},
		{ title: '视频', key: 'face_video', align: 'center',
			render:(h,params) =>{
			   return h('span',{
				 domProps: {
				    innerHTML: '<video controls="controls" style="width:30%;"><source src="'+params.row.face_video+'" type="audio/mpeg" /></video>'
				}
			   })
		}},
		{ title: '融合后视频', key: 'video_url', align: 'center',
			render:(h,params) =>{
			   return h('span',{
				 domProps: {
				    innerHTML: '<video controls="controls" style="width:30%;"><source src="'+params.row.video_url+'" type="audio/mpeg" /></video>'
				}
			   })
		}},
		{ title: '状态', key: 'status', align: 'center', render:(h,params) =>{
			 let sub_type = '未处理';
		    if (params.row.status == '0') {
				sub_type = '融合中';
			}else if (params.row.status == '1') {
				sub_type = '任务提交成功';
			}else if (params.row.status == '2') {
				sub_type = '任务提交失败';
			}else if (params.row.status == '3') {
				sub_type = '融合成功';
			}else if (params.row.status == '4') {
				sub_type = '融合失败';
			}
			return h('span',{},sub_type);
		 }}
		 
		]
	}
  },
  mounted:function(){
	this.getTaskList();
  },
  computed:{

  },
  methods:{
	getTaskList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/figure/aiTaskList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.task_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	}
  }
}
</script>
